// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__tzQpc","title":"styles_title__3opnS","spacer":"styles_spacer__3wilG","switch":"styles_switch__zQSMb","active":"styles_active__1XHIb"};